import React, { useState, useEffect } from 'react';
import AddPais from './AddPais';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function GestionPaises() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [paises, setPaises] = useState([]);
    const [editPais, setEditPais] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [paisToDelete, setPaisToDelete] = useState(null);
    const [dataChanged, setDataChanged] = useState(false); // Estado para controlar la recarga de datos
    const { user } = useUser();

    const fetchPaises = async () => {
        try {
            const response = await fetch(`${server}/MgPaises`);
            const data = await response.json();

            setPaises(data.$values);
            console.log(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar los paises: ' + error,
            });
        }
    };

    useEffect(() => {
        fetchPaises();
    }, [dataChanged]);

    const handleNewPais = () => {

        fetchPaises();
        setEditPais(null);
        console.log('si paso');
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleOpenDialog = (pais) => {
        setPaisToDelete(pais);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setPaisToDelete(null);
    };

    const handleDeletePais = async () => {
        if (paisToDelete) {
            try {
            
                const username = ''+user.codigoUsuario+'/';
                
                const response = await fetch(`${server}/MgPaises/${paisToDelete.idPais}/${username}`, {
                    method: 'DELETE'
                });
                
                if (response.ok) {
                    handleCloseDialog();
                    setDataChanged(prev => !prev); // Toggle para recargar datos
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'País eliminado con éxito',
                    });
                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }
            } catch (error) {
                console.error('Error al eliminar el país:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar el país: ' + error,
                });
            }
        }
    };

    const filteredPaises = paises.filter(pais => pais.nombrePais?.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <>
            <div className="x_title">

            </div>
            <div className="x_content">
                <br />
                <AddPais handleNewPais={handleNewPais} editPais={editPais} />
                <div className="ln_solid" />

                <h2>Paises Existentes</h2>

                <div className="row">
                    <div className="col-md-5 col-sm-4 offset-md-3">
                        <TextField
                            variant="outlined"
                            label="Buscar país"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Nombre País</TableCell>
                                            <TableCell align="right">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredPaises.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pais) => (
                                            <TableRow key={pais.idPais}>
                                                <TableCell component="th" scope="row">
                                                    {pais.nombrePais}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditPais(pais)} color="primary" disabled={!tienePermiso('Editar País')}>
                                                        Editar
                                                    </Button>
                                                    <Button onClick={() => handleOpenDialog(pais)} color="secondary" disabled={!tienePermiso('Eliminar País')}>
                                                        Eliminar
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredPaises.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>
                            <Dialog
                                open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que deseas eliminar el país seleccionado?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">
                                        Cancelar
                                    </Button>
                                    <Button onClick={handleDeletePais} color="primary" autoFocus>
                                        Eliminar
                                    </Button>
                                </DialogActions>
                            </Dialog>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GestionPaises